/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../SmoothScroll";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const MedicalResource = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  return (

    <>
    <title>Medical Records | Citrus Diagnostic Center Crystal River</title>
    <meta name="description" content="Access and manage your medical records easily at Citrus Diagnostic Center, Crystal River. We ensure secure handling of your diagnostic and imaging information." />
   
    <div className="flex justify-center items-center pt-24">
      <div className="w-full sm:w-4/5 flex flex-col items-center pb-8 lg:pb-16">
        <h1
          
          className="text-[#d78558] font-robout lg:text-6xl md:text-4xl text-3xl pt-20 capitalize text-center leading-tight sm:leading-snug font-black"
        >
          REQUEST IMAGING STUDIES AND REPORTS
        </h1>

        <div className="md:text-left md:w-full text-center flex flex-col justify-center items-center lg:pt-20 pt-12 mx-4">
          <h2 className="lg:text-4xl text-3xl text-[#d78558] lg:ps-0 font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
            Access to your patients imaging studies and reports just got easier
          </h2>
          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 px-4 pb-8 w-full sm:w-4/5 md:w-full font-robout break-words">
            As a valued referring provider to Citrus Diagnostic Center, we are
            thrilled to offer you seamless access to your patient images via our
            new partnership we have forged with Clearpath, the leading national
            platform for records and diagnostic image fulfillment.
          </p>

          <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
            Benefits of Using Clearpath
          </h2>
          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 w-full sm:w-4/5 md:w-full px-4 pb-8 font-bold font-robout break-words">
            Clearpath enables a secure, electronic access and provides:
          </p>

          <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
            <li>An easy, secure way to submit imaging requests</li>
            <li>
              Faster image request fulfillment (i.e. less time to get acquire
              images)
            </li>
            <li>Reliable, secure transmission and viewing</li>
            <li>
              Convenient viewing options with formats that include ISO, ZIP (for
              existing viewer/PACS), and portal login via web browser
            </li>
          </ul>

          <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
            Getting Started
          </h2>
          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 w-full sm:w-4/5 md:w-full px-4 pb-8 font-bold font-robout">
            How to Request Imaging Studies & Reports:
          </p>

          <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
            <li>Submit a request directly to our center.</li>
            <li>Reliable, secure transmission and viewing</li>
            <li>
              Provide the following details:
              <ul className="xl:text-[1.33rem] mt-4 list-disc text-base sm:text-lg flex flex-col gap-3 w-full text-white px-6 sm:px-8 mx-4 sm:mx-8 text-left font-robout">
                <li>Name</li>
                <li>Email</li>
                <li>Phone</li>
                <li>Any additional necessary information</li>
              </ul>
            </li>
          </ul>

          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 w-full sm:w-4/5 md:w-full md:px-8 px-4 pb-8 mx-4 text-left font-robout break-words">
            To send us a request for your patient’s radiology report and images,
            please reach out us directly and we will process a digital release
            of your patient images.
          </p>

          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white w-full pb-8 flex flex-col justify-start gap-2 text-left font-robout break-words">
            <span className="lg:text-4xl md:text-3xl text-2xl text-[#d78558] font-bold pb-4">
              Requestor Setup Instructions
            </span>
            <a
              href="https://www.myclearpath.com/requestor-setup"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-2/5 mx-4 break-words underline"
            >
              https://www.myclearpath.com/requestor-setup
            </a>
          </p>

          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white w-full lg:ps-0 px-4 sm:px-8 mx-4 pb-8 flex flex-col justify-start gap-2 text-left font-robout">
            <span className="lg:text-4xl md:text-3xl text-2xl text-[#d78558] font-bold pb-4">
              External Provider Upload Quick Guide
            </span>

            <button
             aria-label="Quick Guide"
              onClick={() => window.open("/quickguide.pdf", "_blank")}
              className="group relative inline-flex h-14 w-40 sm:w-52 items-center rounded-full px-6 sm:px-8 font-semibold text-white bg-transparent overflow-hidden"
            >
              <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>
              <span className="relative text-sm sm:text-base">
                <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <OpenInNewIcon className="!w-4 !h-4 sm:!w-5 sm:!h-5" />
                  Download
                </span>
                <span className="absolute flex flex-row gap-2 top-0 opacity-0 w-full h-full translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <OpenInNewIcon className="!w-4 !h-4 sm:!w-5 sm:!h-5" />
                  Download
                </span>
              </span>
            </button>
          </p>

          <p className="xl:text-[1.33rem] text-base sm:text-lg text-white w-full lg:ps-0 px-4 sm:px-8 mx-4 pb-8 flex flex-col justify-start gap-2 text-left font-robout">
            <span className="lg:text-4xl md:text-3xl text-2xl text-[#d78558] font-bold pb-4">
              To Create/Login Clearpath Account
            </span>
            <a
              href="https://patient.myclearpath.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-[256px]"
            >
              <button  aria-label=" Click Here" className="group relative inline-flex h-14 w-40 sm:w-52 items-center rounded-full px-6 sm:px-8 font-semibold text-white bg-transparent overflow-hidden">
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative text-sm sm:text-base">
                  <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <OpenInNewIcon className="!w-4 !h-4 sm:!w-5 sm:!h-5" />
                    Click Here
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 opacity-0 w-full h-full translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <OpenInNewIcon className="!w-4 !h-4 sm:!w-5 sm:!h-5" />
                    Click Here
                  </span>
                </span>
              </button>
            </a>
          </p>
        </div>
      </div>
    </div>
     </>
  );
};

export default MedicalResource;
